globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.CheckAll = (function() {

    function CheckAll($html) {
        this.$html = $html;
    }

    CheckAll.init = function($html) {
      $html.find('.check-all').on('click', function(){
        var $this = $(this);
        var action = $this.data('action');
        var $checkboxesContainer = $($this.data('checkboxes-container'));

        switch(action) {
          case 'check_all':
            $checkboxesContainer.find('input[type=checkbox]').prop('checked', true).trigger('change').uniform().update();
          break;
          case 'uncheck_all':
            $checkboxesContainer.find('input[type=checkbox]').prop('checked', false).trigger('change').uniform().update();
          break;
        }

        return false;
      });
    }

    CheckAll.prototype = {
        init: function() {}
    }

    return CheckAll;

})();
